// src/utils/tagutils.js

/**
 * Utilities for handling tags in messages, chat logs, and notepad.
 */

/**
 * Normalize a tag by trimming whitespace and converting to lowercase.
 * Example: "  Important " -> "important"
 */
export function normalizeTag(tag) {
  return tag.trim().toLowerCase();
}

/**
 * Validate a tag string. Returns true if the tag matches allowed pattern.
 * This example allows 1-20 alphanumeric characters.
 */
export function validateTag(tag) {
  const pattern = /^[a-z0-9]{1,20}$/i;
  return pattern.test(tag);
}

/**
 * Load global tags for suggestions/autocomplete.
 * This is a placeholder that returns example tags.
 */
export function loadGlobalTags() {
  // Replace with real backend call later if needed.
  return ['important', 'todo', 'urgent', 'review'];
}
